"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isTrainee(object) {
    return checkTrainee(object).fulfilled;
}
exports.isTrainee = isTrainee;
function checkTrainee(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("profileId"), __1.hasString("job"), __1.hasString("school"), __1.hasString("company"), __1.hasNumber("currentMonth").optional().nullable(), __1.hasNumber("totalMonths").optional().nullable()).withOptions(options).explain();
}
exports.checkTrainee = checkTrainee;
//# sourceMappingURL=Trainee.js.map